import $ from 'jquery';
import isString from 'lodash/isString';
import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';
import { DEFAULT_MESSAGE } from './validator-constants';

export { DEFAULT_MESSAGE };

  /**
   * Ensures that an element is not missing a value. This is different from a
   * required attribute as the validation occurs on submit by the validator
   * verses natively in the browser.
   *
   * @param {string} dataAttr - The data attribute receiving the missing
   * validation
   * @returns {Function} Runs through the validation
   */
export const makeValidateMissing = (dataAttr = 'validateMissing') => ($el) => {
  let errorMessage = $el.data('errorMessage');
  let message = $el.data(dataAttr);
  let hasValue = !!$el.val();
  const type = $el.prop('type');

  if (type === 'radio') {
    const nameProp = $el.prop('name');
    const $inputs = $(document.getElementsByName(nameProp));
    const validElements = $inputs.filter((_, input) => get(input, 'validity.valid'));
    if (validElements.length !== $inputs.length) {
      return '';
    }

    const $checked = $inputs.filter(':checked');
    if ($checked.length) {
      return '';
    }

    hasValue = false;
    const validateSelector = `[data-${kebabCase(dataAttr)}]`;
    const $customErrorMessages = $inputs.filter(validateSelector);
    if ($customErrorMessages.length) {
      message = $customErrorMessages.eq(0).data(dataAttr);
    }

    const $defaultErrorMessage = $inputs.filter('[data-error-message]');
    if ($defaultErrorMessage.length) {
      errorMessage = $defaultErrorMessage.eq(0).data('errorMessage');
    }
  }

  if (type === 'checkbox' && !$el.is(':checked')) {
    hasValue = false;
  }

  if (!hasValue) {
    if (isString(message)) {
      return message;
    }

    return errorMessage || DEFAULT_MESSAGE;
  }

  return '';
};


// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/validate-missing.js